import ApiService from './api.service';

export interface DateDimensionCustomPeriod {
  id: string;
  variant: string | null;
  start_date: string;
  end_date: string;
  period_category: string;
  period_name: string;
}

interface ListResponse {
  total_records: number;
  total_pages: number;
  records: DateDimensionCustomPeriod[];
}

interface VariantsResponse {
  variants: string[];
}

interface BulkResponse {
  records: DateDimensionCustomPeriod[];
}

export class DateDimensionCustomPeriodService {
  async getVariants(): Promise<string[]> {
    const result = await ApiService.getInstance().request(
      'GET',
      '/datedimensioncustomperiods/variants'
    ) as VariantsResponse;
    return result.variants;
  }

  async find(variant: string | null): Promise<DateDimensionCustomPeriod[]> {
    const filter = variant === null
      ? JSON.stringify({ variant: null })
      : JSON.stringify({ variant });

    const result = await ApiService.getInstance().request(
      'GET',
      '/datedimensioncustomperiods',
      { filter, limit: 10000 }
    ) as ListResponse;
    return result.records;
  }

  async bulkSave(
    variant: string | null,
    periods: Omit<DateDimensionCustomPeriod, 'id' | 'variant'>[]
  ): Promise<DateDimensionCustomPeriod[]> {
    const result = await ApiService.getInstance().request(
      'POST',
      '/datedimensioncustomperiods/bulk',
      { variant, periods }
    ) as BulkResponse;
    return result.records;
  }
}

export const dateDimensionCustomPeriodService = new DateDimensionCustomPeriodService();
